import tourReducer from './tour';
export * from './tour';
export * from './tour.types';

export default tourReducer;
